import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomerCard } from '@ridango/components';
import { Router } from '@angular/router';
import Env from '@ridango/core/env';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class CardsPurchaseFacadeService {
    private _isPurchaseByCard = new BehaviorSubject<boolean>(false);
    private _selectedCard = new BehaviorSubject<CustomerCard | undefined>(undefined);

    constructor(
        private router: Router,
        private translate: TranslateService
    ) {}

    get isPurchaseByCard(): boolean {
        return this._isPurchaseByCard.value;
    }
    get selectedCard(): CustomerCard {
        return this._selectedCard.value;
    }

    private setPurchaseByCard(value: boolean) {
        this._isPurchaseByCard.next(value);
    }

    private setSelectedCard(card: CustomerCard | undefined) {
        this._selectedCard.next(card);
    }

    reset(): void {
        this.setSelectedCard(undefined);
        this.setPurchaseByCard(false);
    }

    navigateToPurchaseFlow(env: Env, selectedCard: CustomerCard): void {
        if (env.ENABLE_PURCHASE_V2) {
            this.setPurchaseByCard(true);
            this.setSelectedCard(selectedCard);
            this.router.navigate([this.translate.currentLang, 'purchase-v2', 'product-area']);
        } else {
            this.router.navigate([this.translate.currentLang, 'purchase', 'tickets']);
        }
    }
}
